var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", {
    staticClass: "portal-menu-wrapper",
    domProps: { innerHTML: _vm._s(_vm.menuContent) },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }